import { DatePicker, List } from "antd";
import styles from "./CheckListReportTab.module.css";
import { FaCalendarAlt } from "react-icons/fa";
import SearchInput from "../../../components/searchInput/SearchInput";
import { useNavigate } from "react-router-dom";
import { AntdDropdown } from "../../../components";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import ChecklistMiddleware from "../../../store/Middlewares/ChecklistMiddleware";
import moment from "moment";
import AlertAction from "../../../store/Actions/AlertActions";
import { MdSearch } from "react-icons/md";
import '../override.css';


const CheckListReportTab = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const {t , i18n} = useTranslation();
  const [ReportList, setReportList] = useState([])
  const [SelectedLocation, setSelectedLocation] = useState('')
  const [date, setDate] = useState(new Date())
  const [dateFrom, setdateFrom] = useState('')
  const [dateFromModal, setdateFromModal] = useState(false)
  const [dateTo, setdateTo] = useState('')
  const [dateToModal, setdateToModal] = useState(false)
  const [location, setlocation] = useState()
  const CheckListReport = useSelector(state => state.CheckListReducer.CheckListReport)
  const CheckListReportPagination = useSelector(state => state.CheckListReducer.CheckListReportPagination)
  
  
  useEffect(() => {
      getCheckList()
      getLocation()
      getLanguage();
}, [])


  const getLanguage = async () => {
    try {
        const language = localStorage.getItem('@selectedLanguage');
        i18n.changeLanguage(language)
    } catch (e) {
        console.log(e)
    }
  };

  const getCheckList = () => {
    let userData = {
      location_id: SelectedLocation,
      date_from: dateFrom,
      date_to: dateTo,
      next_page_url: undefined
    }
    dispatch(ChecklistMiddleware.getChecklistReports(userData))

  }


  const onSearchList = () => {
    if ((!dateFrom && !dateTo) || (dateFrom && dateTo)) {
      let userData = {
        location_id: SelectedLocation,
        date_from: dateFrom,
        date_to: dateTo,
        next_page_url: undefined
      }
      dispatch(ChecklistMiddleware.getChecklistReports(userData))
    }
    else if ((dateFrom && !dateTo) || (dateTo && !dateFrom)) {
      dispatch(AlertAction.ShowAlert({ type: "error", message: 'Please select date from and date to!' }))
    }
  }

  const getLocation = () => {
    dispatch(ChecklistMiddleware.getLocations())
      .then((data) => {
        setlocation(data?.data)
      })
      .catch((e) => {
        console.log(e)
      })
  }

 

  const onPressLoadMore = () => {
    let userData = {
      location_id: SelectedLocation,
      date_from: dateFrom,
      date_to: dateTo,
      next_page_url: CheckListReportPagination?.links?.next,

    }
    dispatch(ChecklistMiddleware.getChecklistReports(userData))
  };

  const loadMore =
  CheckListReportPagination?.links?.next ? (
      <div
        style={{
          textAlign: 'center',
          marginTop: 12,
          height: 32,
          lineHeight: '32px',
          display: 'flex', justifyContent: 'center'
        }}
      >
        <button onClick={onPressLoadMore} className={styles.loadMore_button}>
          Load More
        </button>
      </div>
    ) : null;

  
  const onChangeDateFrom = (date, dateString) => {
    // console.log('onChangeDateFrom', dateString);
    setdateFrom(moment(dateString).format('YYYY-MM-DD'))
  };
  const onChangeDateTo = (date, dateString) => {
    // console.log('onChangeDateFrom', dateString);
    setdateTo(moment(dateString).format('YYYY-MM-DD'))
  };
  return (
    <div className={styles.mainCon}>
      <div className={styles.firstRow}>
        <div className={styles.firstRowLeft}>
        <DatePicker
          className='date_picker'
          placeholder={t("Date From")}
          style={{
            backgroundColor: "#202020",
            color: "#F6921E",
            border: "2px solid #F6921E",
          }}
          suffixIcon={<FaCalendarAlt className={styles.calendarIcon} />}
          onChange={onChangeDateFrom}
        />
        <DatePicker
          className='date_picker'
          placeholder={t("Date To")}
        
          style={{
            backgroundColor: "#202020",
            color: "#F6921E",
            border: "2px solid #F6921E",
          }}
          suffixIcon={<FaCalendarAlt className={styles.calendarIcon} />}
          onChange={onChangeDateTo}
        />
        </div>
        <div className={styles.firstRowRight}>
        {/* <AntdDropdown
            name={'Status'}
            // label={'Role'}
            className={'yellow_border_class'}
            // onChange={handleChange}
            placeholder={'Location'}
            options={[{ value: 'Working', option: 'Working' },
            { value: 'Pending', option: 'Pending' }]}
            style={{ width: '100%', height: '20px', borderColor: 'red' }}
          /> */}
          <AntdDropdown
            // name={'Select Location'}
            placeholder={t('Select Location')}
            // label={'Role'}
            className={'yellow_border_class'}
            onChange={(val) => setSelectedLocation(val)}
            options={
              location?.map((item) => { return ({ value: item?.id, option: item?.address }) })
            }
            style={{ width: '100%', height: '20px', borderColor: 'red' }}
          />
          </div>
      </div>
      <div className={styles.secondRow}>
        {/* <SearchInput placeholder={"Search"} style={{height: '50px', width: '100%'}} /> */}
        <button onClick={() => onSearchList()} className={styles.Search_button}>
            <MdSearch
              style={{ width: 20, height: 20 }}
              color={"#ffff"}
            />
            {t("Search")}
          </button>
      </div>
      <List
        grid={{
          gutter: 16,
          //   xs: 2,
          sm: 1,
          md: 1,
          lg: 1,
          xl: 2,
          xxl: 2,
        }}
        className={styles.list}
        dataSource={CheckListReport}
        footer={loadMore}
        renderItem={(item) => (
          console.log('item',item),
          <div
            key={item?.id}
            className={styles.listItem}
            onClick={() =>
              navigate("/contractorHome/Checklist/ChecklistReport", { state: { reportData: item } })
            }
          >
            <div className={styles.listName}>
              <h2>{t("Report # ")}{item?.id}</h2>
              <h3>{item?.date
                ? moment(item?.date).format('MM-DD-YYYY')
                : ''}</h3>
            </div>
            <div className={styles.listFirstRow}>
              <div className={styles.FirstCol}>
                <span>{t("Checklist")}</span>
                <p>{item?.name}</p>
              </div>
              <div className={styles.SecondCol}>
                <span>{t("Item")}</span>
                <p>{item?.items?.length}</p>
              </div>
              <div className={styles.SecondCol}>
                <span>%{t("Done")}</span>
                <p>{item?.completed_percent}</p>
              </div>
            </div>
            <div className={styles.listSecondRow}>
              <div className={styles.FirstCol}>
                <span>{t("Completed by")}</span>
                <p>{item?.completed_by}</p>
              </div>
              <div className={styles.ThirdCol}>
                <span>{t("Location")}</span>
                <p>{item?.job_location?.address}</p>
              </div>
            </div>
          </div>
        )}
      />
    </div>
  );
};
export default CheckListReportTab;
